module.exports = __webpack_public_path__ + "media/images/application/placeholder/facebook-preview-63a3379e47948dbf7232727655310672.png";